import colors from '../assets/variables/colors';

/**
 * Sets the tenant color CSS variable from the CSS variables
 * This should be called early in the application initialization
 */
export const setTenantColor = (): void => {
  // Use the initialization function from the colors object
  colors.initializeTenantColor();
};

export default setTenantColor;
